class SourceFileService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }

  getSourcePreview(sourceFile) {
    let batchId = sourceFile.batchId;
    let name = sourceFile.name;

    let url = `${this.config.apiRoot}/batches/${batchId}/sourceFiles/${name}`;
    return this.httpDim.get(url, {});
  }

  getSources(batchId) {
    let url = `${this.config.apiRoot}/batches/${batchId}/sourceFiles`;
    return this.httpDim.get(url, {});
  }

}

SourceFileService.$inject = ['httpDim', 'config'];

export default SourceFileService;




// WEBPACK FOOTER //
// ./app/common/sourceFileService/sourceFileService.service.js